import React, { Component } from 'react';
import { View, Text } from 'react-native';

export default class ErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    /** TODO: Log error to bugsnag */
    console.error({ error, info });
  }

  render() {
    /** TODO: Update with better error state */
    if (this.state.hasError) {
      return (
        <View
          style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}
        >
          <Text>Something went wrong</Text>
        </View>
      );
    }

    return this.props.children;
  }
}
